"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Star = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Star = function Star() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M.242 10.425a.588.588 0 01-.216-.647l.096-.3a.587.587 0 01.527-.42l7.66-.611 2.938-7.062a.611.611 0 01.611-.383h.312a.587.587 0 01.564.383l2.949 7.062 7.66.611a.588.588 0 01.528.42l.096.3c.081.232.01.49-.18.647l-5.778 4.964 1.774 7.445a.611.611 0 01-.228.635l-.348.192a.6.6 0 01-.671 0l-6.522-3.956-6.557 3.992a.6.6 0 01-.672 0l-.263-.18a.611.611 0 01-.228-.635l1.726-7.493-5.778-4.964z"
  });
};

exports.Star = Star;